import React, { useState, useEffect } from "react"

const OverviewWidget = props => {
  // set up state
  const [overviewWidget, setOverviewWidget] = useState(false)

  // load widget when component loads
  useEffect(() => {
    // set up tradingview script
    const script = document.createElement("script")
    script.type = "text/javascript"
    script.async = true
    script.src = "https://s3.tradingview.com/tv.js"
    document.getElementsByTagName("head")[0].appendChild(script)

    // configure overview widget widget when script loads
    script.onload = () => {
      setOverviewWidget(true)
      new window.TradingView.MediumWidget({
        symbols: [["CSE-CSE:AION|12M"]],
        chartOnly: false,
        width: "100%",
        height: 400,
        locale: "en",
        colorTheme: "light",
        gridLineColor: "rgba(240, 243, 250, 0)",
        trendLineColor: "#2962FF",
        fontColor: "#787B86",
        underLineColor: "rgba(41, 98, 255, 0.3)",
        underLineBottomColor: "rgba(41, 98, 255, 0)",
        isTransparent: false,
        autosize: false,
        container_id: "tradingview_01aa0",
      })
    }
  }, [])

  return (
    <div className="tradingview-widget-container">
      <div id="tradingview_01aa0"></div>
      <div className="tradingview-widget-copyright">
        <a
          href="https://www.tradingview.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className="blue-text">AION Quotes</span>
        </a>{" "}
        by TradingView
      </div>
    </div>
  )
}

export default OverviewWidget
